module.exports = __webpack_public_path__ + "static/assets/6d679fd9385a2f2f3f18f206e7b41cbb.svg";